import { useState } from 'react';
import { ChevronDown, X } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@components/ui/popover';
import { Checkbox } from '@components/ui/checkbox';

export function MultiSelect({ value, options, onChange, placeholder = 'Select…' }: { value: string[]; options: string[]; onChange: (v: string[]) => void; placeholder?: string }) {
  const [q, setQ] = useState('');
  const all = [...new Set([...options, ...value])];
  const shown = all.filter((o) => o.toLowerCase().includes(q.toLowerCase()));
  const toggle = (o: string) => onChange(value.includes(o) ? value.filter((x) => x !== o) : [...value, o]);
  return (
    <div>
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" className="glass-input flex h-10 w-full items-center justify-between rounded-xl px-3 text-left text-sm">
            <span className="truncate text-muted-foreground">{value.length ? `${value.length} selected` : placeholder}</span>
            <ChevronDown className="h-4 w-4 text-muted-foreground" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-72 p-2" align="start">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="glass-input mb-2 h-9 w-full rounded-lg px-2 text-sm outline-none" />
          <div className="h-64 overflow-y-auto">
            {shown.map((o) => (
              <label key={o} className="flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm hover:bg-muted">
                <Checkbox checked={value.includes(o)} onCheckedChange={() => toggle(o)} />
                <span className="truncate">{o}</span>
              </label>
            ))}
            {shown.length === 0 && <p className="px-2 py-4 text-center text-xs text-muted-foreground">No matching labels</p>}
          </div>
        </PopoverContent>
      </Popover>
      {value.length > 0 && (
        <div className="mt-1.5 flex flex-wrap gap-1">
          {value.map((v) => (
            <span key={v} className="flex items-center gap-1 rounded-full bg-primary/10 px-2 py-0.5 text-[11px] font-medium text-primary">
              {v}<button type="button" aria-label={`Remove ${v}`} onClick={() => toggle(v)}><X className="h-3 w-3" /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
